import type {
  ApiSuccess,
  CallBridgeResult,
  DeliveryCodeView,
  OrderMessage,
  OrderMessageList,
  OrderTrack,
  PostOrderMessageInput,
} from '@capsico/contracts';
import { api } from './client';

/**
 * Live tracking API (W14). The track payload is the same one the socket pushes on
 * `order.status`, so polling and live updates feed one cache entry.
 */
export async function fetchTrack(orderId: string): Promise<OrderTrack> {
  const res = await api.get<ApiSuccess<OrderTrack>>(`/v1/customer/me/orders/${orderId}/track`);
  return res.data.data;
}

/** The 4-digit code to share with the rider at the door (only the order's owner sees it). */
export async function fetchDeliveryCode(orderId: string): Promise<DeliveryCodeView> {
  const res = await api.get<ApiSuccess<DeliveryCodeView>>(
    `/v1/customer/me/orders/${orderId}/delivery-code`,
  );
  return res.data.data;
}

/** Masked call: the server answers with a bridge number (or the support line) to dial. */
export async function requestCallBridge(orderId: string): Promise<CallBridgeResult> {
  const res = await api.post<ApiSuccess<CallBridgeResult>>('/v1/calls/bridge', {
    orderId,
    to: 'rider',
  });
  return res.data.data;
}

export async function fetchMessages(orderId: string): Promise<OrderMessageList> {
  const res = await api.get<ApiSuccess<OrderMessageList>>(`/v1/orders/${orderId}/messages`);
  return res.data.data;
}

export async function sendMessage(
  orderId: string,
  input: PostOrderMessageInput,
): Promise<OrderMessage> {
  const res = await api.post<ApiSuccess<OrderMessage>>(`/v1/orders/${orderId}/messages`, input);
  return res.data.data;
}
